import React, { useContext, useCallback } from "react";
import t from "module/translations";
import CheckboxField from "component/checkboxField/CheckboxField";
import XLabelField from "component/labelField/XLabelField";
import { getFieldMetaDataWithErrorHandling } from "module/fieldMetaData/getFieldMetaData";
import { TRAINING_CUSTOM_ASSIGNEE_ACHIEVED_FIELD_NAME } from "module/trainingCustomAssignee/constants";
import TrainingCustomAssigneeContext from "module/trainingCustomAssignee/context/TrainingCustomAssigneeContext";
import TrainingCustomAssigneeChangeContext from "module/trainingCustomAssignee/change/TrainingCustomAssigneeChangeContext";
import TrainingCustomAssigneeFieldMetaDataContext from "module/trainingCustomAssignee/validation/fieldMetaData/TrainingCustomAssigneeFieldMetaDataContext";
import { TrainingCustomAssigneeInterface } from "module/trainingCustom/types";

const TrainingCustomAssigneeAchievedFieldContainer: React.FC = () => {
  const { entity } = useContext(TrainingCustomAssigneeContext);
  const { change: changeHelper } = useContext(
    TrainingCustomAssigneeChangeContext
  );
  const { getFieldMetaData } = useContext(
    TrainingCustomAssigneeFieldMetaDataContext
  );

  const trainingCustomAssignee = entity as TrainingCustomAssigneeInterface;

  const change = useCallback(
    (achieved: boolean) => {
      changeHelper({ achieved });
    },
    [changeHelper]
  );

  const { warnings, errors, isEditable } = getFieldMetaDataWithErrorHandling(
    () => getFieldMetaData(TRAINING_CUSTOM_ASSIGNEE_ACHIEVED_FIELD_NAME)
  );

  return isEditable ? (
    <CheckboxField
      {...{
        isChecked: trainingCustomAssignee.achieved,
        change,
        errors,
        warnings,
      }}
    />
  ) : (
    <XLabelField
      {...{
        ...(trainingCustomAssignee.achieved
          ? {
              label: t.yesText,
            }
          : {}),
        warnings,
        errors,
      }}
    />
  );
};

export default React.memo(TrainingCustomAssigneeAchievedFieldContainer);
